import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Valeurs par défaut utilisées tant que l'API n'a pas répondu,
 * ou si un champ image est vide dans la base.
 */
const DEFAULT_SETTINGS = {
  logo: 'https://customer-assets.emergentagent.com/job_laser-pro-akm/artifacts/ylrgfyxm_AKM%20Laser%20logo%20sans%20fond.png',
  heroImage: '/assets/machine-akm-laser-co2-bois.png',
  heroTitle: 'Machines Laser',
  heroSubtitle: 'Professionnelles',
  aboutImage1: 'https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  aboutImage2: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  servicesImage: 'https://images.pexels.com/photos/34718930/pexels-photo-34718930.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  occasionsHeroImage: 'https://images.unsplash.com/photo-1455165814004-1126a7199f9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  contactPhone: '07 61 20 33 70',
  contactAddress: "465 route de l'oasis, Moidieu",
  contactEmail: 'contact@akmlaser.com',
};

const SiteSettingsContext = createContext({
  settings: DEFAULT_SETTINGS,
  loading: true,
  refetch: () => {},
});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/settings`);
      if (res.data) {
        // Merge : remplace uniquement les champs non vides, sinon garde la valeur par défaut
        const merged = { ...DEFAULT_SETTINGS };
        Object.keys(DEFAULT_SETTINGS).forEach((key) => {
          if (res.data[key] !== undefined && res.data[key] !== null && res.data[key] !== '') {
            merged[key] = res.data[key];
          }
        });
        setSettings(merged);
      }
    } catch (err) {
      console.warn('Settings fetch failed, using defaults', err?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refetch: fetchSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
